import { aes } from '@/common/libs/aes/aes.js';

export const storage = new class {
	constructor() {
		return this.prefix = 'SK_';
	}
	
	set(varKey, value = '') {
		varKey = this.prefix + varKey;
		value = aes.encode(value);
		return uni.setStorageSync(varKey, value);
	}
	
	get(varKey) {
		varKey = this.prefix + varKey;
		let value = uni.getStorageSync(varKey);
		if(!value) {
			return '';
		}

		try{
			return aes.decode(value);
		} catch(e) {
			return false;
		}
	}
	
	remove(varKey) {
		varKey = this.prefix + varKey;
		return uni.removeStorageSync(varKey);
	}
	
	clear() {
		return uni.clearStorageSync();
	}
}